import {
  AdminExamLocationManagementRoomRequest,
  ExamCenterLocationRequestVerdictSelection,
} from '@exam-center/exam-location-management';
import { useParams } from '@exam-center/router';

export default function ExamLocationRequestRoomPage() {
  const { roomRequestId } = useParams('/admin/exam-location/requests/:roomRequestId');

  return (
    <>
      <AdminExamLocationManagementRoomRequest roomRequestId={roomRequestId} />
      <ExamCenterLocationRequestVerdictSelection />
    </>
  );
}
